import store from '@store/index'
import {ES, LS, SS} from '@services/ls';
import {_CONST} from '@/constants/constants'
import Vue from 'vue'

const apiUrl = new URL(window.__env.apiUri)
const currentUrl = new URL(location.href)

const getRefreshToken = () => {
  return store.getters['main/refreshToken']
}

const getAccessToken = () => {
  return store.getters['main/accessToken']
}

const getUserIsLoggedIn = () => {
  const user = store.getters['main/getUser']
  return user?.loggedIn
}

const logOut = () => {
  const csrf = getAccessToken()
  store.commit('main/setAccessToken', null)
  store.commit('main/setRefreshToken', null)
  store.commit('main/setUser', {
    loggedIn: false,
  });

  ES.set(_CONST.lsKeys.accessToken, null)
  ES.set(_CONST.lsKeys.refreshToken, null)
  ES.set(_CONST.lsKeys.user, null)
  ES.set(_CONST.lsKeys.login, null)

  SS.set(_CONST.lsKeys.userEcho, null)

  Vue.prototype.$axios.delete(apiUrl.href + 'Auth', {
    withCredentials: true,
    headers: {
      'X-CSRF-TOKEN': csrf,
    }
  }).finally(() => {
    const logOutUrl = new URL('/auth', currentUrl)
    window.location.href = logOutUrl.href
    Vue.prototype.$disconnect()
  })
}


export const authService = {
  async refresh() {
    if (!getUserIsLoggedIn()) return
    const lsAccessCsrfToken = ES.get(_CONST.lsKeys.accessToken)
    const accessCsrfToken = store.getters['main/accessToken']

    if (accessCsrfToken !== lsAccessCsrfToken) {
      ES.set(_CONST.lsKeys.accessToken, null)

      store.commit('main/setAccessToken', null)

      return { data: { accessCsrfToken: lsAccessCsrfToken } }
    }

    try {
      const url = apiUrl.href + 'Auth/refresh'
      return await Vue.prototype.$axios.post(url, null, {
        withCredentials: true,
        headers: {
          'X-CSRF-TOKEN': getRefreshToken(),
        }
      })
    } catch (e) {
      logOut()
      return null
    }
  },
  logOut
}
